import {useState} from 'react'
import {useDebouncedValue} from '@/hooks/common/use-debounced-value'

export type SortDir = 'asc' | 'desc'

export function useTableState(defaultSortBy: string) {
  const [page, setPage] = useState(1)
  const [searchInput, setSearchInput] = useState('')
  const [sortBy, setSortBy] = useState(defaultSortBy)
  const [sortDir, setSortDir] = useState<SortDir>('asc')

  const search = useDebouncedValue(searchInput, 300)

  function updateSearch(value: string) {
    setSearchInput(value)
    setPage(1)
  }

  function toggleSort(column: string) {
    if (sortBy === column) {
      setSortDir((d) => (d === 'asc' ? 'desc' : 'asc'))
    } else {
      setSortBy(column)
      setSortDir('asc')
    }
    setPage(1)
  }

  return {page, setPage, searchInput, setSearchInput: updateSearch, search, sortBy, sortDir, toggleSort}
}
